import { defineMessages } from 'react-intl';

import { withTranslations } from '../../../services/with-translations';

import MissingConnect from './index';

const messages = defineMessages({
  title: {
    description: 'connectMissingCard.title',
    defaultMessage: 'ShipStation Connect Missing',
    id: 'iBzJFP',
  },
  message: {
    description: 'connectMissingCard.message',
    defaultMessage: 'Scan to Print requires ShipStation Connect in order to work. Please set up ShipStation Connect and try again',
    id: 'BoraFa',
  },
  setup: {
    description: 'connectMissingCard.setup',
    defaultMessage: 'Set Up ShipStation Connect',
    id: 'lNyTfg',
  },
  learnMore: {
    description: 'connectMissingCard.learnMore',
    defaultMessage: 'Learn more about ShipStation Connect',
    id: '2hKzFV',
  },
  forMac: {
    description: 'connectMissingCard.forMac',
    defaultMessage: 'For Mac',
    id: 'dt7VGg',
  },
  forWindows: {
    description: 'connectMissingCard.forWindows',
    defaultMessage: 'For Windows',
    id: '2To4VS',
  },
});

export default withTranslations(messages)(MissingConnect);
